import { render, staticRenderFns } from "./ppbkota.vue?vue&type=template&id=531ac5f8"
import script from "./ppbkota.vue?vue&type=script&lang=js"
export * from "./ppbkota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports